export default "__VITE_ASSET__BifTgHxx__"